import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { PresignedUpload, UploadTarget, uploadCampaignCsv } from '../services/campaign-uploads';

interface UploadVariables {
  campaignId: string;
  file: File;
  target?: UploadTarget;
}

/**
 * Mutation hook for uploading one campaign CSV to S3.
 * Exposes upload progress (0–100) alongside the usual mutation state.
 */
export function useUploadCampaignCsv() {
  const [progress, setProgress] = useState(0);

  const mutation = useMutation<PresignedUpload, Error, UploadVariables>({
    mutationFn: ({ campaignId, file, target }) =>
      uploadCampaignCsv(campaignId, file, setProgress, target),
    onMutate: () => {
      setProgress(0);
    },
  });

  return { ...mutation, progress };
}
